import { render, staticRenderFns } from "./UserLoginView.vue?vue&type=template&id=98af78f4&scoped=true&"
import script from "./UserLoginView.vue?vue&type=script&lang=js&"
export * from "./UserLoginView.vue?vue&type=script&lang=js&"
import style0 from "./UserLoginView.vue?vue&type=style&index=0&id=98af78f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98af78f4",
  null
  
)

export default component.exports